import { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAppSelector } from 'hooks/redux';
import { Grid, Column } from 'styles';
import Card from 'components/UI/Card';
import Heading, { Type as HeadingType } from 'components/UI/Heading';
import PageWrapper from 'components/UI/PageWrapper';
import { useParams } from 'react-router';
import Loader from 'components/UI/Loader';
import { CardHeaderTop, CardHeaderTopColumn } from '../styled';
import { Lwm2mDetails } from 'models/lwm2m';
import { lwm2mDetailsSelector } from 'store/lwm2mState/lwm2mState';

const Lwm2mDetailsPage: FC = () => {
  const { isLoading }: Lwm2mDetails = useAppSelector(lwm2mDetailsSelector);
  const { id } = useParams();

  const softwareHistoryResult = useMemo(() => {
    return (
      <Card>
        <CardHeaderTop>
          <CardHeaderTopColumn>
            <Heading type={HeadingType.h3} uppercase>
              <FormattedMessage id="connectivity.software_history" />
            </Heading>
          </CardHeaderTopColumn>
        </CardHeaderTop>
      </Card>
    );
  }, []);

  const logsResult = useMemo(() => {
    if (!id || isLoading) {
      return null;
    }
    return (
      <Card>
        <CardHeaderTop>
          <CardHeaderTopColumn>
            <Heading type={HeadingType.h3} uppercase>
              <FormattedMessage id="connectivity.device_shadow" />
            </Heading>
          </CardHeaderTopColumn>
          <CardHeaderTopColumn>
            <div>{isLoading && <Loader size="small" />}</div>
          </CardHeaderTopColumn>
        </CardHeaderTop>
        {/* <ShadowTree shadows={deviceShadow || []} /> */}
      </Card>
    );
  }, [id, isLoading]);

  // Render device info
  const deviceInfoContent = useMemo(() => {
    if (!id) {
      return null;
    }
    if (isLoading) {
      return <Loader center />;
    }
    return <div />;
  }, [id, isLoading]);

  return (
    <PageWrapper>
      {deviceInfoContent}
      <Grid>
        <Column $marginRight>{logsResult}</Column>
        <Column>{softwareHistoryResult}</Column>
      </Grid>
    </PageWrapper>
  );
};

export default Lwm2mDetailsPage;
